import React from 'react'
import Logo from '../images/train-with-reggie.svg'
import { Link, animateScroll as scroll } from 'react-scroll'
import { slide as Menu } from 'react-burger-menu'
import { useState } from 'react'

export default function Header() {
  const scrollToTop = () => {
    scroll.scrollToTop();
  };

  const [isMenuOpen, handleMenu] = useState(false);
  const handleCloseMenu = () => {
    handleMenu(false);
  };
  const handleStateChange = (state) => {
    handleMenu(state.isOpen);
  };
  
  return (
      <header>
        <img src={ Logo } alt='Reggie Hightower' className='logo' onClick={scrollToTop} />

        <Menu right noOverlay isOpen={isMenuOpen} onStateChange={handleStateChange}>
          <ul>
              <li className="navitem">
                <Link 
                  activeClass="active" 
                  to="about" 
                  spy={true} 
                  smooth={true} 
                  offset={-50} 
                  duration={500}
                  onClick={() => handleCloseMenu()}
                >
                  About
                </Link> 
              </li>
              <li className="navitem">
                <Link 
                  activeClass="active" 
                  to="services" 
                  spy={true} 
                  smooth={true} 
                  offset={-50} 
                  duration={500}
                  onClick={() => handleCloseMenu()}
                >
                  Services
                </Link>
              </li>
              <li className="navitem">
                <Link 
                  activeClass="active" 
                  to="contact" 
                  spy={true} 
                  smooth={true} 
                  offset={-50} 
                  duration={500}
                  onClick={() => handleCloseMenu()}
                >
                  Contact
                </Link>
              </li>
          </ul>
        </Menu>
      </header>
  )
}
